/**
 * Import Dependency
 */
import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import * as moment from 'moment'
import * as _ from 'lodash'
import lang from 'lodash/lang'
import injectSheet from 'react-jss'
import cx from 'classnames'
import qs from 'qs'
import styles from 'assets/styles/components/Wrap'
import { Elements, StripeProvider } from 'react-stripe-elements'
import { Capacitor } from '@capacitor/core'
import { Button, Modal } from 'antd-mobile'
import { FiMapPin, FiPhoneCall } from 'react-icons/fi'
import { MdDirectionsCar } from 'react-icons/md'
import { AiFillShopping, AiOutlineWarning } from 'react-icons/ai'
import { IconContext } from 'react-icons'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import { baseUrl } from 'services/api/config'
import { manifest as defaultManifest } from 'constants/manifest'
import system from '../../services/api/system'

/**
 * Import Container
 */
import TakeawaySummary from 'containers/scenes/TakeawaySummary'
import TakeawayWaitingComponent from 'containers/components/TakeawayWaiting'
import NavBarContainer from 'containers/components/NavBar'
import NavBarLiteContainer from 'containers/components/NavBarLite'
import NavBarSwiperContainer from 'containers/components/NavBarSwiper'
import CategoryDetailContainer from 'containers/components/CategoryDetail'
import CheckoutContainer from 'containers/scenes/Checkout'
import PageTitleContainer from 'containers/components/PageTitle'
import ConfirmationContainer from 'containers/scenes/Confirmation'
import WaiterLoginContainer from 'containers/scenes/WaiterLogin'
import FooterContainer from 'containers/components/Footer'
import DialogComponent from 'containers/hoc/Dialog'

import DirectoryPage from 'components/scenes/DirectoryPage'
import ProtectedRoute from 'components/ProtectedRoute'
import TableList from 'components/TableList'
import WaiterNumberPad from 'components/WaiterNumberPad'

import { Merchant } from 'models/merchant'
import URLParser from 'helpers/urlParser'
import cloudinary from 'helpers/cloudinary'
import { gtag } from 'helpers/gtag'
import loggerService from 'services/logger'
import { IPHONEX_WIDTH } from 'constants/mediaQuery'
import { ERROR_CODE_001, ERROR_CODE_002, ERROR_CODE_003, ERROR_CODE_004, ERROR_CODE_005 } from 'constants/app'
import {
  DELIVERY_PROMOCODES,
  MERCHANT_SNAKEKING,
  MERCHANT_GOLDENPIG,
  MERCHANT_YEUNGWOOTONG,
  MERCHANT_YATBUNKITCHEN,
  MERCHANT_GRANDDINGHOISE,
} from 'constants/merchant'
import healthService from 'services/api/health'
function closest (el, selector) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el
    }
    el = el.parentElement
  }
  return null
}
class Wrap extends Component {
	stripeKey = process.env.REACT_APP_STRIPE_API_KEY;

	constructor (props) {
	  super(props)
	  this.state = {
	    isRenderWarningDialogHOC: false,
	    warningDialogMessage: '',
	    errorCode: '',
	    isContinueRender: true,
	    isGoBack: false,
	    shouldShowPromoImage: false,
	    promoImageUrl: '',
	    isOpenWelcomeModal: false,
	    isOpenUpdateModal: false,
	    isShowRedBar: false,
	    refreshTimeSlotsHandle: null,
	    isLoginWaiter: false,
	    requireLoginWaiter: false,

	    premodalDate: moment(),
	    premodalTime: null,
	    calendarOpen: false,
	    enableTakeaway: false,
	    enableSDelivery: false,
	    passcode: '',
	    showErrorMessage: false,
	  }
	  this.ws = null
	  this.getTakeaway()
	  this.getSDelivery()
	}

	componentDidMount = async () => {
	  const {
	    // history,
	    // location,
	    orders,
	    basket,
	    registerUser,
	    createCustomer,
	    getMerchant,
	    getBasket,
	    requestCreateBasket,
	    addToBasket,
	    createBasket,
	    joinBasket,
	    resetOrder,
	    getCategories,
	    setIsTakeaway,
	    setIsDelivery,
	    setIsShop,
	    setIsStoreDelivery,
	    setCardOnly,
	    setTakeawayAvailable,
	    setDeliveryAvailable,
	    redeemPromoCode,
	    removePromoCode,
	    updateParams,
	    updatePackages,
	    updatePromocodes,
	  } = this.props
	  let user = this.props.user

	  window.logout = () => {
	    this.props.logout()
	    setTimeout(() => {
	      window.location.reload()
	    })
	  }
	  const urlParser = new URLParser(window.location.href)
	  const params = urlParser.getParams()
	  const isWaiterWeb = urlParser.isWaiterWeb()
	  gtag('event', 'load', {
	    event_label: 'load',
	    event_category: 'load',
	    value: 1,
	    non_interaction: true,
	  })
	  if (urlParser.getQuery('ref')) {
	    window.sessionStorage.setItem('ref', urlParser.getQuery('ref'))
	    gtag('event', 'campaign', {
	      event_label: 'campaign',
	      event_category: 'campaign',
	      value: urlParser.getQuery('ref'),
	      non_interaction: true,
	    })
	  }

	  updateParams(params)
	  let {
	    p: payload,
	    m: merchantId,
	    t: table,
	    o: orderId,
	    c: promoCode = basket.promoCode || '',
	    w: welcomeMessage,
	    flushcookies,
	    takeaway,
	    h: hash,
	    delivery,
	    pkg: packages = this.props.packages,
	    cardonly,
	    shop,
	    sdelivery: storeDelivery,
	    requireWaiterLogin,
	    rwl,
	    f: firstPage,
	    u: memberId,
	    err: error,
	    readonly,
	    dir: directoryPage,

	    datetime,
	    address,
	  } = params

	  if (!datetime) {
	    datetime = _.get(this.props.form, 'datetime')
	  }

	  if (error) {
	    throw new Error({ code: error })
	  }

	  if (directoryPage) {
	    document.body.style.backgroundColor = 'rgba(41,41,41,0.85)'
	  } else {
	    document.body.style.backgroundColor = null
	  }

	  if (rwl) {
	    requireWaiterLogin = rwl
	  }

	  if (datetime) {
	    this.props.setForm({ datetime })
	  }
	  if (address) {
	    this.props.updateAddress(address)
	  }

	  if (isWaiterWeb) {
	    const oldVersion = _.get(
	      [...document.getElementsByTagName('META')].filter((o) => o.name === 'ui-version'),
	      '[0].content',
	    )
	    if (oldVersion) {
	      const newVersion = await healthService.getWaiterVersion()
	      if (oldVersion !== newVersion) {
	        this.setState({
	          isOpenUpdateModal: true,
	        })
	      }
	    }
	  }

	  if (requireWaiterLogin) {
	    this.props.setForm({})
	    this.props.clearBasket()
	    this.setState({
	      requireLoginWaiter: true,
	    })
	  }
	  const isRefresh = !merchantId
	  let promocodes = promoCode
	  const isMultiPromocode = promoCode.includes(',')

	  if (payload) {
	    merchantId = payload.split(':')[0]
	  }
	  // get merchantId when f5 after waiter login
	  if (_.get(user, 'permissions.0')) {
	    // if using ?p=
	    if (_.get(user, 'permissions.0', '').split(':')[1]) {
	      merchantId = _.get(user, 'permissions.0', '').split(':')[0]
	    }
	  }

	  if (flushcookies) {
	    window.localStorage.clear()
	    alert('cookies cleared')
	  }

	  if (welcomeMessage) {
	    this.setState({
	      isOpenWelcomeModal: true,
	      welcomeMessage,
	    })
	  }

	  // if no form.datetime, go back to fill form
	  if (storeDelivery && !datetime) {
	    console.log('sdelivery !datetime')
	    const params = qs.stringify({
	      m: merchantId,
	      dir: true,
	      ...(_.get(this.props.query, 'params.pkg') && { pkg: this.props.query.params.pkg }),
	    })
	    window.location.href = `${window.location.protocol}//${window.location.host}?${params}`
	  }

	  // if query string contains table
	  const merchantChanged = basket.merchantId && merchantId !== basket.merchantId && !isRefresh

	  const isDelivery = !!(delivery || this.usingDeliveryPromoCode(params.c) || (basket.isDelivery && isRefresh))
	  const isShop = !!(shop || window.location.hostname.startsWith('shop') || (basket.isShop && isRefresh))
	  const isStoreDelivery = !!(
	    storeDelivery ||
			window.location.hostname.startsWith('storedelivery') ||
			(basket.isStoreDelivery && isRefresh)
	  )
	  const isTakeaway = !!(
	    takeaway ||
			window.location.hostname.startsWith('take') ||
			(basket.isTakeaway && !table) ||
			isDelivery ||
			isShop ||
			isStoreDelivery
	  )

	  const isCardOnly = basket.isCardOnly || cardonly === 'true'

	  this.isPreOrder = !isTakeaway && !basket.table && (table || orderId) && basket.merchantId === merchantId

	  // shipping
	  if (merchantChanged && basket.shipping) {
	    this.props.setShipping(null)
	  }
	  // packages
	  if (
	    merchantChanged ||
			(merchantId && !params.pkg) // enter page with m= but not pkg=
	  ) {
	    await updatePackages(null)
	    packages = ''
	  }
	  if (params.pkg) {
	    await updatePackages(params.pkg)
	    packages = params.pkg
	  }
	  if (packages) {
	    packages = packages.split(',')
	  }

	  // promocodes
	  if (
	    merchantChanged ||
			(merchantId && !params.c) || // enter page with m= but not c=
			!isMultiPromocode
	  ) {
	    await updatePromocodes(null)
	    promocodes = ''
	  }
	  if (params.c && isMultiPromocode) {
	    updatePromocodes(params.c)
	  }
	  // if (promocodes) {
	  //   promocodes = promocodes.split(',')
	  // }

	  if ((!user.token || payload) && !(user.permissions || []).some((p) => payload.indexOf(p) === 0)) {
	    user = await registerUser(payload, hash)
	  }
	  const isWaiter = (user.permissions || []).indexOf(merchantId + ':waiter') >= 0

	  // log
	  loggerService.init({ merchantId })

	  await createCustomer()

	  setCardOnly(isCardOnly)
	  setIsDelivery(isDelivery)
	  setIsShop(isShop)
	  setIsStoreDelivery(isStoreDelivery)
	  setIsTakeaway(isTakeaway)

	  if (isTakeaway) {
	    table = undefined // remove table to notify backend as a takeway order
	  }

	  let createOrder = true
	  if (orderId) {
	    // if already has an order created
	    try {
	      const newBasket = await joinBasket({ id: orderId })
	      merchantId = newBasket.merchantId
	      table = newBasket.table
	    } catch (error) {
	      this.setState({
	        isRenderWarningDialogHOC: true,
	        warningDialogMessage: 'dialog.joinbasketErr',
	        errorCode: ERROR_CODE_001,
	      })
	      console.log('joinBasket err')
	      return
	    }
	  } else if (basket.id) {
	    // if basket is already created previously
	    // e.g. after refresh

	    if (!merchantId || merchantId === basket.merchantId) {
	      merchantId = basket.merchantId
	      try {
	        if (isTakeaway) {
	          const newBasket = await createBasket({
	            merchantId: merchantId,
	            isDelivery,
	          })

	          orderId = newBasket.id
	          await setTakeawayAvailable(true)
	          if (isDelivery) {
	            const isInDeliveryTimeslot = await this.props.getIsInDeliveryTimeslot()
	            await setDeliveryAvailable(isInDeliveryTimeslot)
	          }
	        } else {
	          // getBasket, get previous basket from server
	          const newBasket = await getBasket({
	            id: basket.id,
	          })

	          // if no client has no table selected and basket is in pending state
	          // or ...
	          if (
	            (!table || basket.table === table) &&
							basket.table === newBasket.table &&
							newBasket.status === 'pending'
	          ) {
	            orderId = basket.id

	            // only set table value for no takeaway order
	            table = basket.table
	            await createBasket(newBasket)
	          } else if (table || basket.table || isWaiter) {
	            if (!table) {
	              if (!isWaiter) {
	                if (table === undefined && !this.props.query.params.dir) {
	                  this.setState({
	                    isRenderWarningDialogHOC: true,
	                    warningDialogMessage: 'dialog.joinbasketErr',
	                    errorCode: ERROR_CODE_002,
	                  })
	                  return
	                }
	              } else {
	                table = basket.table
	              }
	            }

	            // check if this basket has been created more than 12 hrs
	            if (
	              this.isPreOrder ||
								!table ||
								moment().diff(newBasket.createdAt, 'hours') >= 12 ||
								isWaiter
	            ) {
	              // directly create a new basket
	            } else {
	              await requestCreateBasket({
	                table: table || basket.table,
	              })
	              createOrder = false
	            }
	          }
	        }
	      } catch (err) {
	        if (err.response && err.response.status >= 400 && err.response.status < 500) {
	          if (err.response.data.error === 'not for takeaway') {
	            await setTakeawayAvailable(false)
	          } else if (err.response.data.error === 'not for delivery') {
	            await setDeliveryAvailable(false)
	          } else {
	            await requestCreateBasket({
	              table: table,
	            })
	            createOrder = false
	          }
	        } else {
	          table = null
	        }
	      }
	    }
	  }

	  // no match, new request (merchant changed)

	  if (!merchantId) {
	    // if no merchant id is input
	    this.setState({
	      isRenderWarningDialogHOC: true,
	      warningDialogMessage: 'dialog.noMerchant',
	    })
	    console.log('!merchantId')
	    return
	  }

	  getCategories(merchantId, packages, datetime).then((categories) => {
	    orders.filter((o) => _.get(o, 'steps.length')).map((orderSetItem) => {
	      const matchedCategory = _.find(categories, { id: orderSetItem.dishId })
	      if (!matchedCategory) {
	        this.props.deleteOrderByDishId(orderSetItem.dishId)
	      }
	    })
	  })

	  let merchant
	  try {
	    merchant = await getMerchant(merchantId)
	    if (!merchant) {
	      throw {
	        message: '!merchant',
	        warningDialogMessage: 'dialog.noMerchant',
	        errorCode: ERROR_CODE_005,
	      }
	    }
	    this.setRefreshTimeSlotsJob()
			if(_.get(merchant,'id')==='44a11ac3-3f81-4308-ba2f-e173162b46a1'&& params.m==='44a11ac3-3f81-4308-ba2f-e173162b46a1'){
				window.location.href='https://c.dimorder.com/d2c/44a11ac3-3f81-4308-ba2f-e173162b46a1?init=true&dineIn=true'
			}
	    if (_.get(merchant, 'setting.useCustomerWebV2') && params.t && params.m) {
	      window.location.href = `https://c.dimorder.com/d2c/${params.m}?t=${params.t}`
	      return
	    }
	    if (_.get(merchant, 'setting.useCustomerWebV2') && params.t && params.m) {
	      window.location.href = `https://c.dimorder.com/d2c/${params.m}?t=${params.t}`
	      return
	    }
	    if (params.dir && directoryPage) {
	      window.location.href = `https://c.dimorder.com/d2c/${params.m}?init=1`
	      return
	    }
	    if (takeaway || storeDelivery) {
	      window.location.href = `https://c.dimorder.com/d2c/${params.m}?init=1`
	      return
	    }
	    if (_.get(merchant, 'setting.qrcode') && params.t && params.m && !_.get(merchant, 'setting.hotelMode')) {
	      throw {
	        warningDialogMessage: 'dialog.rescan',
	        errorCode: ERROR_CODE_004,
	      }
	    }
	    if (promoCode) {
	      const result = await redeemPromoCode({ merchantId: merchant.id, promoCode })
	      if (!_.get(result, 'success')) {
	        removePromoCode()
	      }
	      if (_.get(result, 'data.image')) {
	        this.setState({
	          shouldShowPromoImage: true,
	          promoImageUrl: result.data.image,
	        })
	      }
	    }

	    if (firstPage) {
	      const m = new Merchant(merchant)
	      const storeDeliveryTimeslots = m.getFutureStoreDeliveryTimeslots()
	      const takeawayTimeslots = m.getFutureTakeawayTimeslots()
	      console.log({
	        storeDeliveryTimeslots: _.uniqBy(storeDeliveryTimeslots, (o) => o.format('L')).map((o) =>
	          o.format('L'),
	        ),
	        takeawayTimeslots: _.uniqBy(takeawayTimeslots, (o) => o.format('L')).map((o) => o.format('L')),
	      })

	      const availableTimeslots = _([...storeDeliveryTimeslots, ...takeawayTimeslots])
	        .uniqBy((o) => o.format())
	        .sortBy((o) => +o)
	        .value()

	      const minDate = _.first(availableTimeslots)
	      if (minDate) {
	        console.log({ minDate: minDate.format() })
	        this.setState({
	          premodalDate: minDate,
	          premodalTime: minDate.format('HH:mm'),
	        })
	      }
	    }

	    // Generate manifest.json which use merchant.name as the value of name and short_name.
	    // Create a link element with manifest in href.
	    // Append the link to html's head.
	    if (merchant && merchant.name) {
	      const manifest = {
	        ...defaultManifest,
	        name: merchant.name,
	        short_name: merchant.name,
	      }
	      const manifestJson = JSON.stringify(manifest)
	      const blob = new Blob([manifestJson], { type: 'application/json' })
	      const manifestURL = URL.createObjectURL(blob)

	      const link = document.createElement('link')
	      link.rel = 'manifest'
	      link.href = manifestURL
	      document.getElementsByTagName('head')[0].appendChild(link)
	    }

	    // Generate App icon base on merchant's cover image. (cloudinary)
	    // Fix the size of the image.
	    // Create a link and append it to html's head.
	    if (merchant && merchant.images && merchant.images.cover) {
	      const coverUrl = merchant.images.cover
	      const iconSizes = [72, 96, 128, 144, 152, 192, 384, 512]
	      iconSizes.forEach((sizes) => {
	        // Resize the cover image to certain size of icon.
	        const param = `w_${sizes},h_${sizes},c_fill/`
	        const iconUrl = coverUrl.split('/image/upload').join('/image/upload/' + param)

	        // Generate link elemenet and append it to head.
	        const link = document.createElement('link')
	        link.rel = 'apple-touch-icon'
	        link.href = iconUrl
	        link.sizes = `${sizes}x${sizes}`
	        document.getElementsByTagName('head')[0].appendChild(link)
	      })
	    }
	  } catch (err) {
	    console.error(err)
	    const update = {
	      isRenderWarningDialogHOC: true,
	      errorCode: ERROR_CODE_003,
	    }
	    if (_.get(err, 'errorCode')) {
	      update.errorCode = err.errorCode
	    }
	    if (_.get(err, 'warningDialogMessage')) {
	      update.warningDialogMessage = err.warningDialogMessage
	    }
	    this.setState(update)
	    return
	  }

	  if (isWaiter) {
	    // create websoket for update menu
	    this.startWebSocket()
	    // get active tables and their orders. (if is waiter)
	    this.props.getActiveTables()
	    this.getActiveTablesTimer = setInterval(() => {
	      this.props.getActiveTables()
	    }, 10 * 1000)

	    // refresh menusCache
	    this.refreshMenuTimer = setInterval(() => {
	      this.props.updateForceRefreshMenu(true)
	    }, 180 * 1000)
	  }

	  if (!isWaiter) {
	    // getOrderHistories by interval.
	    // if prev order.status !== 'paid' and res order.status === 'paid'
	    // redirect to /basket/checkout_complete
	    // same order can't triger twice.
	    this.orderHistoryStatus = {}
	    this.findNewPaidOrders()
	    this.findNewPaidOrderTimer = setInterval(() => {
	      this.findNewPaidOrders()
	    }, 10 * 1000)
	  }

	  orders.find((order) => {
	    if (merchant.id !== order.merchantId) {
	      this.props.deleteOrderByDishId(order.dishId)
	    }
	  })

	  const nonConfirmedOrders = orders.find((ele) => {
	    // if non-confirmed ele exists for the same merchant
	    return !ele.confirmed && ele.steps && merchant && ele.merchantId === merchant.id
	  })

	  const isNonConfirmedOrderExist = !lang.isEmpty(nonConfirmedOrders)
	  const setTokens = this.props.location.pathname.split('/category/set/')
	  const setCategoryId = setTokens[1] ? setTokens[1].split('/')[0] : ''
	  const categoryId = _.get(/\/category(\/set)?\/([^/]*)/.exec(window.location.pathname), '2', '')

	  if (isNonConfirmedOrderExist && setCategoryId && setCategoryId !== nonConfirmedOrders.dishId) {
	    this.setState({
	      isGoBack: false,
	      isContinueRender: false,
	    })
	  } else if (isNonConfirmedOrderExist && categoryId && categoryId !== nonConfirmedOrders.dishId) {
	    this.setState({
	      isGoBack: false,
	      isContinueRender: false,
	    })
	  } else {
	    this.setState({
	      isContinueRender: true,
	      isRenderWarningDialogHOC: false,
	    })
	  }

	  if (orderId) {
	    console.log('use basket.id: orderId')
	    return
	  }

	  if (!this.isPreOrder && !isWaiter) {
	    await resetOrder()
	  }
	  // if no basket has been created
	  if (createOrder) {
	    if (isTakeaway) {
	      try {
	        // createBasket without table id to show it's a takeaway
	        await createBasket({
	          merchantId: merchantId,
	          isDelivery,
	        })
	        if (isDelivery) {
	          const isInDeliveryTimeslot = await this.props.getIsInDeliveryTimeslot()
	          await setDeliveryAvailable(isInDeliveryTimeslot)
	        }
	      } catch (err) {
	        if (err.response && err.response.status >= 400 && err.response.status < 500) {
	          if (err.response.data.error === 'not for takeaway') {
	            await setTakeawayAvailable(false)
	          }
	          if (err.response.data.error === 'not for delivery') {
	            await setDeliveryAvailable(false)
	          }
	        }
	      }
	    } else if (table) {
	      await createBasket({
	        merchantId: merchantId,
	        table: table,
	      })
	    } else {
	      await addToBasket({
	        ...basket,
	        merchantId: merchantId,
	        table: '',
	      })
	    }
	  }

	  if (!promoCode && merchantChanged) removePromoCode()
	};

	getTakeaway = async () => {
	  const takeaway = await system.getTakeaway()
	  this.setState({ enableTakeaway: takeaway.enable })
	  }

	  getSDelivery = async () => {
	    const sDelivery = await system.getSDelivery()
	    this.setState({ enableSDelivery: sDelivery.enable })
	  }

	startWebSocket = () => {
	  return
	  const { basket, user, updateForceRefreshMenu } = this.props
	  const socketUrl = `${baseUrl.startsWith('https://') ? 'wss' : 'ws'}://${baseUrl.split(
			'://',
		)[1]}/c/menu/subscribe`
	  const socketParams = qs.stringify({
	    merchant_id: basket && basket.merchantId,
	    token: user && user.token,
	  })
	  const ws = new WebSocket(`${socketUrl}?${socketParams}`)
	  ws.onopen = () => console.log('ws **Connected to server')
	  ws.onmessage = async (event) => {
	    const message = JSON.parse(event.data)
	    console.log('ws **Message:', message)

	    // Once update menu event received,
	    // send message.ID back to stop server from sending more duplicated messages.
	    ws.send(JSON.stringify({ id: message.ID }))

	    // Wait 2 seconds for db update.
	    // After 2 seconds waiting, set menuCache.forceRefreshMenu to true.
	    // Once menuCache.forceRefreshMenu is changed from false to true,
	    // Fetch the latest menu in componentDidUpdate, CategoryDetailList.
	    // After fetch menu, set menuCache.forceRefreshMenu back to false.
	    setTimeout(() => {
	      updateForceRefreshMenu(Boolean(message))
	    }, 2000)
	  }
	  ws.onclose = () => {
	    console.log('ws **Disconnected to server')
	    this.ws = null
	    this.startWebSocket()
	  }
	  ws.onerror = (err) => {
	    console.error('ws **onError', err)
	    this.ws = null
	    this.startWebSocket()
	  }
	  this.ws = ws
	};

	async findNewPaidOrders () {
	  const { history, query, basket, user, merchant, getOrderHistories } = this.props

	  const isWaiter = merchant && user && (user.permissions || []).indexOf(merchant.id + ':waiter') >= 0
	  const merchantId = (merchant && merchant.id) || (basket && basket.merchantId) || (query && query.params.m)
	  const res = await getOrderHistories(merchantId)
	  res.forEach((order) => {
	    if (
	      !isWaiter && // > redirect only in customer version.
				order.status === 'paid' &&
				this.orderHistoryStatus[order.id] !== undefined && // > prevnent first render redirect
				this.orderHistoryStatus[order.id] !== 'paid' &&
				!order.takeaway
	    ) {
	      const path = '/basket/checkout_complete'
	      history.push(path)
	    }
	    this.orderHistoryStatus[order.id] = order.status
	  })
	}

	componentDidUpdate = (prevProps) => {
	  if (this.props.location.pathname !== prevProps.location.pathname) {
	    gtag('event', 'route change', {
	      event_category: 'route change',
	      event_label: 'route change',
	      value: this.props.location.pathname,
	      non_interaction: true,
	    })
	  }
	  // If path changed and current path is set menu, const isSetMenu to be true.
	  // If waiter.numberPad.display is !isSetMenu, update waiter number pad display.
	  if (
	    this.props.waiter.numberPad.display === null ||
			this.props.location.pathname !== prevProps.location.pathname
	  ) {
	    const path = this.props.location.pathname
	    const isSetMenu = path.includes('/category/set')
	    if (this.props.waiter.numberPad.display !== !isSetMenu) {
	      this.props.updateDisplayWaiterNumberPad(!isSetMenu)
	    }
	  }

	  if (
	    this.props.location.pathname !== prevProps.location.pathname &&
			prevProps.merchant &&
			prevProps.merchant.id === this.props.merchant.id
	  ) {
	    const { switchBottomSheet, updateNavBarSwiperExpand, orders } = this.props
	    switchBottomSheet(false)
	    updateNavBarSwiperExpand(false)

	    const isPrevPageASet = prevProps.location.pathname.indexOf('category/set') > -1
	    // const isCurrPageASet = this.props.location.pathname.indexOf("category/set") > -1;
	    const isCurrPageCheckout = this.props.location.pathname.indexOf('basket/checkout') > -1

	    // if prev page is a set
	    if (isPrevPageASet && !isCurrPageCheckout) {
	      // check if category key changed
	      const prevTmp = prevProps.location.pathname.split('/category/set/')[1]
	      const currTmp = this.props.location.pathname.split('/category/set/')[1]
	      let prevCatId = ''
	      let currCatId = ''

	      if (prevTmp) {
	        prevCatId = prevTmp.split('/')[0]
	      }
	      if (currTmp) {
	        currCatId = currTmp.split('/')[0]
	      }

	      if ((prevCatId.length > 0 && !currCatId) || prevCatId !== currCatId) {
	        const isPrevOrderNotConfirmed = orders.find((ele) => {
	          return ele.dishId === prevCatId && !ele.confirmed && ele.merchantId === this.props.merchant.id
	        })

	        if (isPrevOrderNotConfirmed) {
	          console.log('isPrevOrderNotConfirmed')

	          // eslint-disable-next-line react/no-did-update-set-state
	          this.setState({
	            isGoBack: false,
	            isContinueRender: false,
	          })
	        } else {
	          // eslint-disable-next-line react/no-did-update-set-state
	          this.setState({
	            isContinueRender: true,
	            isRenderWarningDialogHOC: false,
	          })
	        }
	      }
	    } else {
	      // eslint-disable-next-line react/no-did-update-set-state
	      this.setState({
	        isContinueRender: true,
	        isRenderWarningDialogHOC: false,
	      })
	    }
	  }
	};

	componentWillUnmount = () => {
	  if (this.state.refreshTimeSlotsHandle != null) {
	    clearInterval(this.state.refreshTimeSlotsHandle)
	  }
	  clearInterval(this.findNewPaidOrderTimer)
	  clearInterval(this.getActiveTablesTimer)
	  clearInterval(this.refreshMenuTimer)
	};

	setRefreshTimeSlotsJob = () => {
	  this.refreshTimeslots()
	  if (!this.state.refreshTimeSlotsHandle) {
	    var refreshTimeSlotsHandle = setInterval(() => {
	      const isHome = this.props.history.location.pathname === '/home'
	      if (isHome) {
	        this.refreshTimeslots()
	      }
	    }, 6000)
	    this.setState({
	      refreshTimeSlotsHandle,
	    })
	  }
	};

	refreshTimeslots = async () => {
	  const { merchant, getTimeslot, setTakeawayAvailable } = this.props

	  if (merchant === null) {
	    return
	  }
	  try {
	    const res = await getTimeslot(merchant.id)
	    // if no available timeslot
	    if (res.length === 0) {
	      await setTakeawayAvailable(false)
	    } else {
	      await setTakeawayAvailable(true)
	    }
	  } catch (err) {
	    await setTakeawayAvailable(false)
	  }
	};

	usingDeliveryPromoCode = (code) => {
	  return !!DELIVERY_PROMOCODES.filter((c) => c === code)[0]
	};

	renderDialogHOC = (type, title, message, callback) => {
	  const _type = type || ''
	  const _title = title || ''
	  const _message = message || ''
	  const _callback = callback || null

	  switch (_type) {
	    case 'confirm':
	      return (
	        <DialogComponent triggerModal={_callback} dialogType="confirm" title={_title} message={_message} />
	      )

	    case 'warning':
	      return (
	        <DialogComponent triggerModal={_callback} dialogType="warning" title={_title} message={_message} />
	      )

	    default:
	      break
	  }
	};

	renderUpdateModal = () => {
	  const { intl } = this.props
	  return (
	    this.state.isOpenUpdateModal && (
	      <DialogComponent
	        dialogType="confirm"
	        confirmBtnText={intl.formatMessage({ id: 'update' })}
	        noCancel={true}
	        title={intl.formatMessage({ id: 'updateMessage' })}
	        triggerModal={(ok) => {
	          if (ok) {
	            window.location.reload()
	          }
	        }}
	      />
	    )
	  )
	};

	renderWelcomeMessageModal = () => {
	  return (
	    this.state.isOpenWelcomeModal && (
	      <DialogComponent
	        triggerModal={() => {}}
	        dialogType="confirm"
	        title={this.state.welcomeMessage}
	        // message={this.state.welcomeMessage}
	        onClose={() => {
	          this.setState({
	            isOpenWelcomeModal: false,
	          })
	        }}
	      />
	    )
	  )
	};

	renderRedBar = (props) => {
	  const { classes, basket, intl, history, merchant } = props
	  const redBarWrapStyle = cx(classes['red-bar'])
	  const redTexts = [
	    intl.formatMessage({ id: 'delivery.redbar' }),
	    intl.formatMessage({ id: 'delivery.redbar2' }),
	    intl.formatMessage({ id: 'delivery.redbar3' }),
	    intl.formatMessage({ id: 'delivery.redbar4' }),
	  ]
	  const path = history.location.pathname
	  const isHome = path === '/home'

	  return (
	    _.get(merchant, 'setting.enableDelivery') &&
			basket.isDelivery &&
			isHome && <div className={redBarWrapStyle}>{redTexts.map((text, i) => <div key={i}>{text}</div>)}</div>
	  )
	};

	onWrapTouchStart = (e) => {
	  // fix touch to scroll background page on iOS
	  if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
	    return
	  }
	  const pNode = closest(e.target, '.am-modal-content')
	  if (!pNode) {
	    e.preventDefault()
	  }
	};

	renderPremodal = () => {
	  const { merchant: m, classes, intl } = this.props
	  if (!m) {
	    return <div />
	  }
	  const premodalStyle = cx(classes.premodal)
	  const sectionStyle = cx(classes.premodalSection)

	  let minDate = new Date()
	  let maxDate = new Date()
	  const merchant = new Merchant(m)
	  const storeDeliveryTimeslots = merchant.getFutureStoreDeliveryTimeslots()
	  const takeawayTimeslots = merchant.getFutureTakeawayTimeslots()
	  const availableTimeslots = _([...storeDeliveryTimeslots, ...takeawayTimeslots])
	    .uniqBy((o) => o.format())
	    .sortBy((o) => +o)
	    .value()

	  // console.log('availableTimeslots', _.uniqBy(availableTimeslots, o => o.format('L')).map(o => o.format('L')))
	  // console.log('takeawayTimeslots', _.uniqBy(takeawayTimeslots, o => o.format('L')).map(o => o.format('L')))
	  // console.log('storeDeliveryTimeslots', _.uniqBy(storeDeliveryTimeslots, o => o.format('L')).map(o => o.format('L')))

	  if (availableTimeslots.length) {
	    minDate = _.first(availableTimeslots).toDate()
	    maxDate = _.last(availableTimeslots).toDate()
	  }
	  const availableDates = _(availableTimeslots).groupBy((timeslot) => timeslot.format('YYYY-MM-DD')).value()

	  const selectedDatetime = moment(
	    moment(this.state.premodalDate).format('YYYY-MM-DD') + ` ${this.state.premodalTime}`,
	  )
	  const availableForTakeaway = !!takeawayTimeslots.filter((t) => selectedDatetime.isSame(t)).length
	  const availableForStoreDelivery = !!storeDeliveryTimeslots.filter((t) => selectedDatetime.isSame(t)).length
	  // console.log({
	  //   availableForTakeaway,
	  //   availableForStoreDelivery,
	  // })

	  return (
	    <Modal
	      visible={true}
	      transparent={false}
	      maskClosable={true}
	      animated={false}
	      title={<div style={{ height: 27 }} />}
	      className={premodalStyle}
	      wrapProps={{ onTouchStart: this.onWrapTouchStart }}
	    >
	      <div className={cx(classes.premodalContainer)}>
	        <section
	          className={cx(classes.premodalCover)}
	          style={{
	            backgroundImage: `url( ${cloudinary.transformation(
								merchant.images.cover,
								`w_${IPHONEX_WIDTH}`,
							)} )`,
	          }}
	        />
	        <section
	          className={sectionStyle}
	          style={{
	            paddingTop: '30px',
	          }}
	        >
	          <div id="branding" style={{ marginBottom: 0, textAlign: 'left', color: '#333' }}>
	            <h1 style={{ marginTop: '0' }}>{merchant.name}</h1>
	            <div style={{ margin: '8px 0' }}>
	              <a
	                style={{
	                  color: '#D5AD40',
	                  display: 'flex',
	                  alignItems: 'center',
	                }}
	                href={`https://maps.google.com/maps?q=${merchant.address}`}
	                target="_blank"
	                rel="noopener noreferrer"
	              >
	                {' '}
	                <FiMapPin style={{ marginRight: 8 }} /> {merchant.address}{' '}
	              </a>
	            </div>
	            {/* <div style={{ margin: '8px 0' }}>
	              <a
	                style={{
	                  color: '#D5AD40',
	                  display: 'flex',
	                  alignItems: 'center',
	                }}
	                href={`tel:${merchant.contact}`}
	                target="_blank"
	                rel="noopener noreferrer"
	              >
	                {' '}
	                <FiPhoneCall style={{ marginRight: 8 }} /> {merchant.contact}{' '}
	              </a>
	            </div> */}
	            {// 蛇王芬
	              merchant.id === MERCHANT_SNAKEKING && (
	                <div style={{ margin: '8px 0' }}>
	                  <a
	                    style={{
	                      color: 'rgb(149, 41, 43)',
	                      display: 'flex',
	                      whiteSpace: 'pre-line',
	                    }}
	                  >
	                    {' '}
	                    <AiOutlineWarning style={{ marginRight: 8 }} />{' '}
	                    {'外賣自取時段\n星期一至日 上午11時至晚上10時30分\n外送時段\n星期一至日 中午12時至晚上9時30分'}{' '}
	                  </a>
	                </div>
	              )}
	            {// 金妹記
	              merchant.id === MERCHANT_GOLDENPIG && (
	                <div style={{ margin: '8px 0' }}>
	                  <a
	                    style={{
	                      color: 'rgb(149, 41, 43)',
	                      display: 'flex',
	                      whiteSpace: 'pre-line',
	                    }}
	                  >
	                    {' '}
	                    <AiOutlineWarning style={{ marginRight: 8, flex: '0 0 15px' }} />
	                    <span>
	                      {' '}
	                      {
	                        '外賣自取時段\n星期一至日 上午11時30分至晚上10時30分\n外送時段\n星期一至日 中午12時至晚上9時30分\n疫情期間，外送員將會送到大厦地面大堂進行交收，煩請見諒，外賣速遞服務最快一小時後送達，請選擇以下的食品到達時間'
	                      }{' '}
	                    </span>
	                  </a>
	                </div>
	              )}
	            {// 養和堂
	              merchant.id === MERCHANT_YEUNGWOOTONG && (
	                <div style={{ margin: '8px 0' }}>
	                  <a
	                    style={{
	                      color: 'rgb(149, 41, 43)',
	                      display: 'flex',
	                      whiteSpace: 'pre-line',
	                    }}
	                  >
	                    {' '}
	                    <AiOutlineWarning style={{ marginRight: 8 }} /> {'截單時間為送餐時間前一天下午五時'}{' '}
	                  </a>
	                </div>
	              )}
	          </div>
	        </section>
	        <section className={sectionStyle}>
	          <div
	            id="date"
	            style={{
	              marginTop: '20px',
	            }}
	          >
	            <p className={cx(classes.premodalSectionTitle)}>送餐日期</p>
	            {!this.state.calendarOpen && (
	              <div
	                className={cx(classes.timeInput)}
	                onClick={() => {
	                  this.setState({ calendarOpen: true })
	                }}
	              >
	                {moment(this.state.premodalDate).format('LL dddd')}
	              </div>
	            )}
	            {this.state.calendarOpen && (
	              <Calendar
	                view="month"
	                onChange={(e) => {
	                  this.setState({
	                    premodalDate: moment(e),
	                    premodalTime: availableDates[moment(e).format('YYYY-MM-DD')][0].format(
	                      'HH:mm',
	                    ),
	                  })
	                }}
	                value={this.state.premodalDate.toDate()}
	                className={cx(classes.premodalCalendar)}
	                tileClassName={cx(classes.premodalCalendarTile)}
	                minDate={minDate}
	                maxDate={maxDate}
	                tileDisabled={({ activeStartDate, date, view }) =>
	                  !availableDates[moment(date).format('YYYY-MM-DD')]}
	              />
	            )}
	          </div>
	          <div
	            id="time"
	            style={{
	              marginTop: '20px',
	            }}
	          >
	            <p className={cx(classes.premodalSectionTitle)}>送餐時間</p>
	            <select
	              className={cx(classes.timeInput)}
	              onChange={(e) => {
	                this.setState({
	                  premodalTime: e.target.value,
	                })
	              }}
	            >
	              {_.map(
	                availableDates[moment(this.state.premodalDate).format('YYYY-MM-DD')],
	                (timeslot) => {
	                  return (
	                    <option key={timeslot.format()} value={timeslot.format('HH:mm')}>
	                      {timeslot.format('HH:mm')}
	                    </option>
	                  )
	                },
	              )}
	            </select>
	          </div>
	        </section>
	        <section className={cx(classes.premodalSection, classes.flexCenter)}>
	          {/* if takeaway is available */}
	          <div
	            onClick={() => {
	              if (!availableForTakeaway) {
	                return
	              }
	              this.props.setForm({ datetime: selectedDatetime.format() }).then(() => {
	                const params = qs.stringify({
	                  m: merchant.id,
	                  takeaway: true,
	                  ...(_.get(this.props.query, 'params.pkg') && {
	                    pkg: this.props.query.params.pkg,
	                  }),
	                })
	                window.location.href = `${window.location.protocol}//${window.location
										.host}?${params}`
	              })
	            }}
	            className={cx(
	              {
	                [classes.disabled]: !availableForTakeaway,
	              },
	              classes.premodalDeliveryTypeSelectBox,
	            )}
	          >
	            {!availableForTakeaway && (
	              <div className={cx(classes.premodalDeliveryTypeSelectBoxDisabledCover)}>
	                {intl.formatMessage({ id: 'servicenotavailable.timeslot' })}
	              </div>
	            )}
	            <h3 className={cx(classes.premodalDeliveryTypeSelectBoxHeader)}>
	              {intl.formatMessage({ id: 'summary.deliveryType.takeaway' })}
	            </h3>
	            <div>
	              {' '}
	              <IconContext.Provider value={{ color: '#95292b', size: '80px' }}>
	                {' '}
	                <AiFillShopping />
	              </IconContext.Provider>{' '}
	            </div>
	            <div className={cx(classes.flex1)} />
	            <div className={cx(classes.premodalDeliveryTypeSelectBoxDesc)}>自己提取，擺脫排隊煩惱</div>
	            {/* <div className={cx(classes.premodalDeliveryTypeSelectBoxDesc)}>45分鐘</div> */}
	            <div className={cx(classes.flex1)} />
	            <div>
	              <button type="button" className={cx(classes.premodalDeliveryTypeButton)}>
									選擇
	              </button>
	            </div>
	          </div>
	          {/* if storeDelivery is available */}
	          <div
	            onClick={() => {
	              if (!availableForStoreDelivery) {
	                return
	              }
	              this.props.setForm({ datetime: selectedDatetime.format() }).then(() => {
	                const params = qs.stringify({
	                  m: merchant.id,
	                  sdelivery: true,
	                  ...(_.get(this.props.query, 'params.pkg') && {
	                    pkg: this.props.query.params.pkg,
	                  }),
	                })
	                window.location.href = `${window.location.protocol}//${window.location
										.host}?${params}`
	              })
	            }}
	            className={cx(
	              {
	                [classes.disabled]: !availableForStoreDelivery,
	              },
	              classes.premodalDeliveryTypeSelectBox,
	              classes.ml1,
	            )}
	          >
	            {!availableForStoreDelivery && (
	              <div
	                className={cx([
	                  classes.premodalDeliveryTypeSelectBoxDisabledCover,
	                  classes.textCenter,
	                ])}
	              >
	                {
	                  '送餐上門'
	                  // intl.formatMessage({ id: 'servicenotavailable.timeslot' })
	                }
	                <br />
									請選擇外送時段的時間
	              </div>
	            )}
	            <h3 className={cx(classes.premodalDeliveryTypeSelectBoxHeader)}>
	              {intl.formatMessage({ id: 'summary.deliveryType.delivery' })}
	            </h3>
	            <div>
	              {' '}
	              <IconContext.Provider value={{ color: '#95292b', size: '80px' }}>
	                {' '}
	                <MdDirectionsCar />
	              </IconContext.Provider>{' '}
	            </div>
	            <div className={cx(classes.flex1)} />
	            <div className={cx(classes.premodalDeliveryTypeSelectBoxDesc)}>外送上門</div>
	            {/* <div className={cx(classes.premodalDeliveryTypeSelectBoxDesc)}>45分鐘</div> */}
	            <div className={cx(classes.flex1)} />
	            <div>
	              <button type="button" className={cx(classes.premodalDeliveryTypeButton)}>
									選擇
	              </button>
	            </div>
	          </div>
	        </section>
	      </div>
	    </Modal>
	  )
	};

	renderDirectory = () => {
	  return <DirectoryPage />
	};

	renderWrapHeader = () => {
	  const { classes, history, intl, user, waiter, basket, isTakeaway, merchant } = this.props

	  const path = history.location.pathname
	  const isWaiter = (user.permissions || []).indexOf(basket.merchantId + ':waiter') >= 0
	  const isCheckout = path === '/basket/checkout'
	  const isHistory = path === '/basket/history'
	  const isTakeawaySummary = path === '/basket/takeaway_summary'
	  const isTakeawayWaiting = path === '/basket/takeaway_waiting'
	  const isCheckoutComplete = path === '/basket/checkout_complete'
	  const isChangeTable = path === '/basket/change_table'
	  const isChangeTableDetail = path === '/basket/change_table/table'
	  const displayNumberPad = waiter.numberPad.display

	  const _orderText = intl.formatMessage({ id: 'history.order' })
	  const _orderRecentText = intl.formatMessage({ id: 'history.order_recent' })
	  const _orderPaidText = intl.formatMessage({ id: 'history.order_paid' })
	  const _tableNumber = _.get(merchant, 'setting.hotelMode')
	    ? intl.formatMessage({ id: 'history.room_no' })
	    : intl.formatMessage({ id: 'history.table_no' })
	  let _tableNoText = ''
	  if (this.props.basket.isStoreDelivery) {
	    _tableNoText = intl.formatMessage({ id: 'summary.deliveryType.delivery' })
	  } else if (isTakeaway) {
	    _tableNoText = intl.formatMessage({ id: 'footer.takeaway_no' })
	  } else {
	    switch (intl.locale) {
	      case 'en':
	        _tableNoText = `${_tableNumber} ${basket.table}`
	        break
	      default:
	        _tableNoText = `${basket.table} ${_tableNumber}`
	        break
	    }
	  }

	  const checkoutHeaderWrapStyle = cx(classes['checkout-header-wrap'])

	  const renderPageTitle = () => {
	    switch (path) {
	      case '/basket/history':
	        return _orderRecentText
	      case '/basket/checkout_complete':
	        return _orderPaidText
	      default:
	        return `${_orderText} (${_tableNoText})`
	    }
	  }
	  const title = renderPageTitle()

	  if (isTakeawaySummary || isTakeawayWaiting) return
	  if (isCheckout || isHistory || isCheckoutComplete) {
	    return (
	      <div className={checkoutHeaderWrapStyle}>
	        <NavBarLiteContainer isHistory={isHistory} isCheckoutComplete={isCheckoutComplete} />
	        <PageTitleContainer title={title} />
	      </div>
	    )
	  } else if (isChangeTable || isChangeTableDetail) {
	    return (
	      <div className={checkoutHeaderWrapStyle}>
	        <NavBarLiteContainer />
	      </div>
	    )
	  } else {
	    return (
	      <React.Fragment>
	        <NavBarContainer />
	        <NavBarSwiperContainer />
	        {isWaiter && displayNumberPad && <WaiterNumberPad />}
	      </React.Fragment>
	    )
	  }
	};

	renderWrapFooter = () => {
	  const {
	    history,
	    // isNavBarSwiperExpanded,
	  } = this.props

	  const path = history.location.pathname
	  const isTakeawaySummary = path === '/basket/takeaway_summary'
	  const isTakeawayWaiting = path === '/basket/takeaway_waiting'
	  const isHistory = path === '/basket/history'
	  const isCheckoutComplete = path === '/basket/checkout_complete'
	  const isChangeTable = path === '/basket/change_table'

	  if (isTakeawaySummary || isTakeawayWaiting || isCheckoutComplete || isChangeTable) {
	    return <div />
	  }

	  return (
	    <div>
	      <Switch>
	        <Route path="/category/set/:id?/:step?">
	          <StripeProvider apiKey={this.stripeKey}>
	            <Elements>
	              <FooterContainer isHistory={isHistory} />
	            </Elements>
	          </StripeProvider>
	        </Route>
	        <Route path="/">
	          <StripeProvider apiKey={this.stripeKey}>
	            <Elements>
	              <FooterContainer isHistory={isHistory} />
	            </Elements>
	          </StripeProvider>
	        </Route>
	      </Switch>
	    </div>
	  )
	};

	renderConfirmationContainer = () => {
	  return <ConfirmationContainer />
	};

	renderHistoryContainer = () => {
	  return <CheckoutContainer isHistory />
	};

	renderCheckoutContainer = () => {
	  return <CheckoutContainer isHistory={false} />
	};

	renderCheckoutComplete = () => {
	  return <CheckoutContainer isHistory isCheckoutComplete />
	};

	renderChangeTable = () => {
	  return <TableList />
	};

	renderTakeawaySummaryContainer = () => {
	  const { orders } = this.props
	  return (
	    <StripeProvider apiKey={this.stripeKey}>
	      <Elements>
	        <TakeawaySummary takeawayOrders={orders} />
	      </Elements>
	    </StripeProvider>
	  )
	};

	renderTakeawayWaitingContainer = () => {
	  return <TakeawayWaitingComponent />
	};

	createBasket = (confirm) => {
	  const { basket, createBasket } = this.props

	  if (confirm) {
	    createBasket({
	      merchantId: basket.merchantId,
	      table: basket.table,
	    })
	  }
	};

	checkIsStepProcessing = () => {
	  const { basket, orders } = this.props

	  const urlParser = new URLParser(window.location.href)
	  const { m: merchantId, t: table } = urlParser.getParams()

	  if ((basket.merchantId !== merchantId || basket.table !== table) && !lang.isEmpty(merchantId)) {
	    return false
	  }

	  orders.some((item) => {
	    if (item.steps) {
	      item.steps.find((step) => {
	        if (step.min <= 0 && step.quantity === 1) {
	          return false
	        }
	        if (step.quantity !== 0) {
	          if (step.quantity >= step.min && (step.quantity <= step.max || step.max === 0)) {
	            return false
	          }
	        }
	        return true
	      })
	    }
	    return false
	  })
	};

	resetStepOrder = (isReset) => {
	  const {
	    history,
	    // match,
	    orders,
	    deleteOrderByDishId,
	  } = this.props

	  if (!isReset) {
	    this.setState(
	      {
	        isContinueRender: true,
	        isGoBack: true,
	      },
	      () => {
	        let _stepProcessingDishId = ''
	        let _isStepProcessing
	        orders.some((item) => {
	          if (item.steps && !item.confirmed) {
	            _isStepProcessing = item.steps.find((step) => {
	              if (step.min <= 0 && step.quantity === 1) {
	                return false
	              }
	              if (step.quantity !== 0) {
	                if (step.quantity >= step.min && (step.quantity <= step.max || step.max === 0)) {
	                  return false
	                }
	              }
	              _stepProcessingDishId = item.dishId
	              return true
	            })

	            // not found => all steps fulfilled
	            if (!_isStepProcessing) {
	              _stepProcessingDishId = item.dishId + '/' + item.steps[item.steps.length - 1].key
	            }
	          }
	          return false
	        })
	        history.replace(`/category/set/${_stepProcessingDishId}`)
	      },
	    )
	  } else {
	    let dishIdByStep = ''
	    // let _isStepProcessing = ''

	    orders.some((item) => {
	      if (item.steps) {
	        item.steps.find((step) => {
	          if (step.quantity < step.min) {
	            dishIdByStep = item.dishId
	            return true
	          }
	          return false
	        })
	      }
	      return false
	    })

	    // orders.some((item) => {
	    //     if (item.steps) {
	    //         dishIdByStep = item.dishId;
	    //     }
	    // });

	    deleteOrderByDishId(dishIdByStep).then(() => {
	      this.setState({
	        isContinueRender: true,
	      })
	    })
	  }
	};

	homePage = () => (
	  <React.Fragment>
	    {!this.state.isGoBack && this.checkIsStepProcessing()}
	    <CategoryDetailContainer
	      shouldShowPromoImage={this.state.shouldShowPromoImage}
	      promoImageUrl={this.state.promoImageUrl}
	      onPromoImageClose={() => {
	        this.setState({
	          shouldShowPromoImage: false,
	        })
	      }}
	    />
	  </React.Fragment>
	);

	loginPage = () => {
	  return (
	    <React.Fragment>
	      {this.renderUpdateModal()}
	      <WaiterLoginContainer />
	    </React.Fragment>
	  )
	};

	categoryPage = () => <p>404, Category Not Found</p>;

	categoryPageWithId = () => (
	  <React.Fragment>
	    {!this.state.isGoBack && this.checkIsStepProcessing()}
	    {<CategoryDetailContainer />}
	  </React.Fragment>
	);

	categoryPageWidthSetId = () => (
	  <React.Fragment>
	    {!this.state.isGoBack && this.checkIsStepProcessing()}
	    {<CategoryDetailContainer />}
	  </React.Fragment>
	);

	render = () => {
	  const {
	    user,
	    classes,
	    basket,
	    merchant,
	    categories,
	    history,
	    // orders,
	    // createBasket,
	    isStickyNavbarSwiper,
	    intl,
	    isTakeaway,
	    isTakeawayAvailable,
	  } = this.props

	  const path = history.location.pathname
	  const isWaiter = (user.permissions || []).indexOf(basket.merchantId + ':waiter') >= 0
	  const isHome = path === '/home'
	  const isTakeawaySummary = path === '/basket/takeaway_summary'
	  const isTakeawayWaiting = path === '/basket/takeaway_waiting'
	  const isCheckoutComplete = path === '/basket/checkout_complete'
	  const urlParser = new URLParser(window.location.href)
	  const isWaiterWeb = urlParser.isWaiterWeb()
	  const { m: merchantId, waiterApp, change_table: changeTable } = urlParser.getParams()

	  if (
	    this.state.requireLoginWaiter ||
			(Capacitor.isNative && !isWaiter) || // waiter app capacitor version
			(waiterApp && !isWaiter) || // waiter app webview version
			(isWaiterWeb && !isWaiter) // waiter web
	  ) {
	    // setStorage('state', { locale: this.props.locale })
	    return this.loginPage()
	  }

	  if (isHome && this.props.query.params.dir && merchantId) {
	    return this.renderDirectory()
	  }

	  if (merchant && categories && isWaiter && isHome) {
	    let cat = categories[0] //  進來後自動到第一個分類
	    if (cat) {
	      if (_.get(cat, 'categories.length')) {
	        cat = cat.categories[0]
	      }
	      let path = `/category/${cat.isSet ? 'set/' : ''}${cat.id}`
	      if (changeTable) {
	        path = '/basket/change_table'
	      }
	      const nonConfirmedOrders = this.props.orders.find((ele) => {
	        // if non-confirmed ele exists for the same merchant
	        return !ele.confirmed && ele.steps && merchant && ele.merchantId === merchant.id
	      })
	      const isNonConfirmedOrderExist = !lang.isEmpty(nonConfirmedOrders)
	      const categoryId = _.get(/\/category(\/set)?\/([^/]*)/.exec(path), '2', '')

	      if (isNonConfirmedOrderExist && categoryId && categoryId !== nonConfirmedOrders.dishId) {
	        this.setState(
	          {
	            isGoBack: false,
	            isContinueRender: false,
	          },
	          () => {
	            history.push(path)
	            console.log('route changed', path)
	          },
	        )
	      } else {
	        history.push(path)
	        console.log('route changed', path)
	      }
	      if (changeTable) {
	        return <div />
	      }
	    }
	  }

	  let wrapStyle = ''
	  if (isStickyNavbarSwiper) {
	    wrapStyle = cx(classes.wrap, classes['wrap-sticky'])
	  } else if (isTakeawaySummary || isTakeawayWaiting || isCheckoutComplete) {
	    wrapStyle = cx(classes['wrap-takeaway'])
	  } else {
	    wrapStyle = cx(classes.wrap)
	  }

	  let dialogElement = ''

	  if (
	    !basket.isTakeaway &&
			basket.createdAt &&
			moment(basket.createdAt)
			  .add(_.get(merchant, 'setting.orderCutOffMins') || 14400, 'minute')
			  .isBefore(moment())
	  ) {
	    console.log('expired!')
	    basket.request = true
	  }
	  if ((basket.request && basket.isTakeaway) || (basket.request && basket.table)) {
	    if (isWaiter) {
	      this.createBasket(true)
	      return <div />
	    } else {
	      const title = intl.formatMessage({ id: 'dialog.reorder' })
	      let message
	      if (basket.isTakeaway) {
	        const _dialogMsgText = intl.formatMessage({ id: 'dialog.reorder_msg_takeaway' })
	        message = _dialogMsgText
	      } else {
	        const _dialogMsgFrontText = intl.formatMessage({ id: 'dialog.reorder_msg_front' })
	        const _dialogMsgBackText = intl.formatMessage({ id: 'dialog.reorder_msg_back' })
	        message = `${_dialogMsgFrontText} ${basket.table} ${_dialogMsgBackText}`
	      }
	      dialogElement = this.renderDialogHOC('confirm', title, message, this.createBasket)
	      return <React.Fragment>{dialogElement}</React.Fragment>
	    }
	  }

	  if (this.state.isRenderWarningDialogHOC) {
	    console.error({
	      isRenderWarningDialogHOC: this.state.isRenderWarningDialogHOC,
	      warningDialogMessage: this.state.warningDialogMessage,
	      errorCode: this.state.errorCode,
	    })
	    loggerService.flush()
	    if (Capacitor.isNative) {
	      this.props.logout()
	      window.location.href = [`${window.location.protocol}//`, window.location.host].join('')
	      return ''
	    }
	    if (isWaiterWeb) {
	      // setStorage('state', { locale: this.props.locale })
	      return this.loginPage()
	    }

	    const title = intl.formatMessage({ id: 'dialog.hint' })
	    let message = intl.formatMessage({ id: this.state.warningDialogMessage || 'dialog.rescan' })
	    if (this.state.errorCode) {
	      message += ` (${this.state.errorCode})`
	    }

	    dialogElement = this.renderDialogHOC('warning', title, message)

	    return <React.Fragment>{dialogElement}</React.Fragment>
	  }

	  if (this.state.isContinueRender || this.state.isGoBack) {
	    if (this.state.isGoBack && history.location.pathname.indexOf('set') > -1) {
	      this.setState({
	        isGoBack: false,
	      })
	    }
	  } else {
	    const _title = intl.formatMessage({ id: 'dialog.warning' })
	    const _message = intl.formatMessage({ id: 'dialog.reorder_step' })

	    dialogElement = this.renderDialogHOC('confirm', _title, _message, this.resetStepOrder)
	    return (
	      <React.Fragment>
	        {this.renderWrapHeader()}
	        {dialogElement}
	        {this.renderWrapFooter()}
	      </React.Fragment>
	    )
	  }

	  let takeawayUnavailableDialog = ''

	  if (_.get(merchant, 'setting.hotelMode') && user.code !== basket.code) {
	    const modalStyle = cx(classes.passcodeDialog)
	    const passcodeInputStyle = cx(classes.passcodeInput)
	    const _dialogConfirmBtnText = intl.formatMessage({ id: 'dialog.confirm_btn' })
	    const _passcodeTitleText = intl.formatMessage({ id: 'dialog.hotel_passcode' })
	    const _passcodeErrorText = intl.formatMessage({ id: 'dialog.hotel_passcode_error' })

		  return (
		  <Modal
	        visible={true}
	        transparent={false}
	        maskClosable={true}
	        animated={false}
		  >
	      <div className={modalStyle}>
	        <span style={{ color: 'black' }}>{_passcodeTitleText}</span>
			    <input
	          className={passcodeInputStyle}
			      placeholder='Passcode'
	          value={this.state.passcode}
	          onChange={(e) => this.setState({ passcode: e.target.value })}
			    />
	          {
	            this.state.showErrorMessage && (
	              <span style={{ color: 'red' }}>{_passcodeErrorText}</span>
	            )
	          }
	        <button
	          className={cx(classes.premodalDeliveryTypeButton)}
	          onClick={() => {
	            this.props.updateHotelPasscode(this.state.passcode)
	              if (this.state.passcode !== basket.code) {
	                this.setState({ showErrorMessage: true })
	              }
	          }}
	        >
	          {_dialogConfirmBtnText}
	        </button>
	      </div>
		  </Modal>
		  )
	  }

	  if (
	  // show dialog if takeaway is unavaiable in takeaway mode
	    (isTakeawayAvailable === false || !this.state.enableTakeaway) &&
			isTakeaway &&
			basket.takeawayStatus === undefined &&
			!isTakeawayWaiting &&
			merchant &&
			!basket.isStoreDelivery &&
			!this.props.query.params.f
	  ) {
	    takeawayUnavailableDialog = this.renderDialogHOC(
	      'warning',
	      intl.formatMessage({ id: 'dialog.takeaway.unavailable.title' }),
	      intl.formatMessage({ id: 'dialog.takeaway.unavailable.msg' }),
	    )
	  }
	  if (merchant && this.props.basket.isDelivery) {
	    if ((this.props.basket.isDeliveryAvailable === false || !this.state.enableSDelivery) && takeawayUnavailableDialog) {
	      takeawayUnavailableDialog = this.renderDialogHOC(
	        'warning',
	        intl.formatMessage({ id: 'dialog.delivery.unavailable.title' }),
	        intl.formatMessage({ id: 'dialog.delivery.unavailable.msg' }),
	      )
	    } else {
	      takeawayUnavailableDialog = ''
	    }
	  }
	  if (_.get(merchant, 'disabled')) {
	    takeawayUnavailableDialog = this.renderDialogHOC(
	      'warning',
	      intl.formatMessage({ id: 'dialog.dineIn.unavailable.title' }),
	      intl.formatMessage({ id: 'dialog.dineIn.unavailable.msg' }) + merchant.contact,
	    )
	  }

	  if (isHome && this.props.query.params.f) {
	    return this.renderPremodal()
	  }
	  return (
	    <React.Fragment>
	      {this.renderWelcomeMessageModal()}
	      {takeawayUnavailableDialog}
	      {this.renderWrapHeader()}
	      {this.renderRedBar(this.props)}
	      <div className={wrapStyle}>
	        <Switch>
	          <ProtectedRoute
	            isTakeaway={basket.isTakeaway}
	            takeawayOrders={basket.takeawayOrders}
	            takeawayStatus={basket.takeawayStatus}
	            basket={basket}
	            exact
	            path="/home"
	            component={this.homePage}
	          />
	          <ProtectedRoute
	            exact
	            takeawayOrders={basket.takeawayOrders}
	            isTakeaway={basket.isTakeaway}
	            takeawayStatus={basket.takeawayStatus}
	            path="/category"
	            component={this.categoryPage}
	          />
	          {/** set category's route MUST befor category */}
	          <ProtectedRoute
	            path="/category/set/:id/:step?"
	            takeawayOrders={basket.takeawayOrders}
	            isTakeaway={basket.isTakeaway}
	            takeawayStatus={basket.takeawayStatus}
	            component={this.categoryPageWidthSetId}
	          />
	          <ProtectedRoute
	            path="/category/:id"
	            takeawayOrders={basket.takeawayOrders}
	            isTakeaway={basket.isTakeaway}
	            takeawayStatus={basket.takeawayStatus}
	            component={this.categoryPageWithId}
	          />
	          <ProtectedRoute
	            path="/tag/:tag"
	            takeawayOrders={basket.takeawayOrders}
	            isTakeaway={basket.isTakeaway}
	            takeawayStatus={basket.takeawayStatus}
	            component={CategoryDetailContainer}
	          />
	          <ProtectedRoute
	            exact
	            takeawayOrders={basket.takeawayOrders}
	            path="/basket"
	            isTakeaway={basket.isTakeaway}
	            takeawayStatus={basket.takeawayStatus}
	            component={() => <p>404, Basket Not Found</p>}
	          />
	          <ProtectedRoute
	            path="/basket/checkout"
	            takeawayOrders={basket.takeawayOrders}
	            isTakeaway={basket.isTakeaway}
	            takeawayStatus={basket.takeawayStatus}
	            component={this.renderCheckoutContainer}
	          />
	          <ProtectedRoute path="/basket/checkout_complete" component={this.renderCheckoutComplete} />
	          <ProtectedRoute path="/basket/change_table" component={this.renderChangeTable} />
	          <ProtectedRoute path="/basket/change_table/table" component={this.renderChangeTable} />
	          <ProtectedRoute
	            path="/basket/confirmation"
	            takeawayOrders={basket.takeawayOrders}
	            isTakeaway={basket.isTakeaway}
	            takeawayStatus={basket.takeawayStatus}
	            component={this.renderConfirmationContainer}
	          />
	          <ProtectedRoute
	            path="/basket/history"
	            takeawayOrders={basket.takeawayOrders}
	            isTakeaway={basket.isTakeaway}
	            takeawayStatus={basket.takeawayStatus}
	            component={this.renderHistoryContainer}
	          />
	          <Route
	            path="/basket/takeaway_summary"
	            isTakeaway={basket.isTakeaway}
	            takeawayStatus={basket.takeawayStatus}
	            component={this.renderTakeawaySummaryContainer}
	          />
	          <Route
	            path="/basket/takeaway_waiting"
	            isTakeaway={basket.isTakeaway}
	            takeawayStatus={basket.takeawayStatus}
	            component={this.renderTakeawayWaitingContainer}
	          />
	        </Switch>
	      </div>

	      {!this.props.query.params.readonly && this.renderWrapFooter()}
	    </React.Fragment>
	  )
	};
}

/**
 * Export
 */
export default injectSheet(styles)(Wrap)



// WEBPACK FOOTER //
// ./src/components/scenes/Wrap.js